<template>
  <div class="reg-body">
    <div
        class="main-image-wrapper"
        style="
        background-image: url('https://us-central1-devil-263810.cloudfunctions.net/images?imageID=btmq2pq23akg00d5a6n0.jpg');
      "
    >
      <div class="main-image-grad"></div>
    </div>
    <form v-if="registrationClosed" class="registration-closed" >
      <div class="form-header warning">
        <h1>REGISTRATION NOW CLOSED</h1>
      </div>
    </form>

    <form  v-if="form && !registrationClosed" @submit.prevent="sendForm()">
      <div class="form-header">
        <h1>Sponsorship Opportunities</h1>
      </div>
      <div
          class="sponsership"
          v-for="(sponserhip, i) in sponsershipTiers"
          :key="i + 'sponsership'"
      >
        <div class="product-price">
          <b>${{ numberWithCommas(sponserhip.amount) }} </b>
          <p style="font-size: 14px; color: grey">{{ sponserhip.title }}</p>
        </div>
        <div class="product-description">
          <b style="font-size: 14px">{{ sponserhip.description }}</b>
          <p style="font-size: 13px; font-weight: light">
            {{ sponserhip.features }}
          </p>
        </div>
      </div>
      <!-- <p>Items with an asterisk (*) are required fields</p> -->
      <!-- <router-link to="/">I'm Already Registered</router-link> -->
      <div v-for="(group, i) in registration" :key="i">
        <h3>{{ group.title }}</h3>
        <label>
          Sponsorship Level
          <select class="w-input big-input" v-model="donation.amount">
            <option value="" hidden>Sponsorship Level</option>
            <option
                v-for="(sponserhip, i) in sponsershipTiers"
                :key="i + 'sponsership'"
                :value="sponserhip.amount"
            >
              {{ sponserhip.title }} - ${{
                numberWithCommas(sponserhip.amount)
              }}
            </option>
          </select>
        </label>
        <label v-for="(field, i) in group.fields" :key="i">
          {{ field.name }}
          <input
              class="w-input big-input"
              @input="logItem($event, field.slug)"
              :type="field.type"
              :placeholder="field.name"
              :v-model="form[field.slug]"
              :required="field.required"
          />
        </label>

      </div>

      <input
          v-model="donation.amount"
          name="amount"
          type="number"
          required="true"
          hidden
      />
      <br/>
      <stripe
          @approve="CCApprove()"
          :donation="donation"
          :address="donation.address"
          :fullName="donation.firstName +' ' +donation.lastName"
          :amount="donation.amount"
          :email="donation.emailAddress"
          :description="'Shalva Movie Night Donation'"
      />
      <p style="text-align: center"><br/>- or -<br/></p>
      <input class="button" type="submit" :value="status"/>
    </form>
  </div>
</template>

<script>
import Bagel from "@bageldb/bagel-db";
import stripe from "../components/stripe";

export default {
  components: {stripe},
  watch: {
    donation: {
      deep: true,
      handler() {
        if (this.donation.amount < 0) this.donation.amount = 0;
      },
    },
  },
  methods: {
    logItem(event, slug) {
      this.donation[slug] = event.target.value;
    },
    setAmount(i) {
      this.donation.amount = this.sponsershipTiers[i].amount;
    },
    CCApprove() {
      this.donation.paid = true;
      this.sendForm();
    },
    async sendForm() {
      this.status = "sending...";
      let db = new Bagel(process.env.VUE_APP_BAGEL_TOKEN);
      await db.collection("sponsorships").post(this.donation)

      this.$router.push("/");
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  async mounted() {
    if (
        !window.location.href.match("shalva") &&
        process.env.NODE_ENV != "development"
    ) {
      this.$router.push("/");
    }
    let form = {};
    for (const group of this.registration) {
      for (const field of group.fields) {
        form[field.slug] = "";
      }
    }
    this.form = form;
    let db = new Bagel(process.env.VUE_APP_BAGEL_TOKEN);
    await db.collection("landingPage").get().then(({data}) => {
      this.registrationClosed = data[0].registrationClosed;
    })
  },
  data() {
    return {
      donation: {
        firstName: "",
        lastName: "",
        emailAddress: "",
        streetAddress: "",
        state: "",
        city: "",
        zipCode: "",
        phoneNumber: "",
        amount: "",
        paid: false,
      },
      openAmount: false,
      selectedSponsership: "",
      form: false,
      status: "Bill Me Later",
      sponsershipTiers: [
        {
          amount: 25000,
          title: "PRODUCER",
          description:
              "Renovate an independent living apartment to house six residents with disabilities.",
          features: `Includes (5) Private Guest Links Sponsorship Listing on Website & Special Acknowledgment During Event Receive (5) 3.5 Gallon Gourmet Popcorn Tins (3 flavors of your choice in each tin) sent to up to (5) viewing locations`,
        },
        {
          amount: 15000,
          title: "DIRECTOR",
          description:
              "Provides a toddler with one year of education and therapies at the Inclusive Preschool.",
          features: `Includes (5) Private Guest Links Sponsorship Listing on Website & Special Acknowledgment During Event Receive (5) 3.5 Gallon Gourmet Popcorn Tins (3 flavors of your choice in each tin) sent to up to (5) viewing locations`,
        },
        {
          amount: 10000,
          title: "PREMIER",
          description:
              "Provides a child with one year of rehabilitative programs at the After School Activity Center.",
          features: `Includes (5) Private Guest Links Sponsorship Listing on Website & Special Acknowledgment During Event Receive (5) 3.5 Gallon Gourmet Popcorn Tins (3 flavors of your choice in each tin) sent to up to (5) viewing locations of your choice`,
        },
        {
          amount: 5000,
          title: "CAMERAMAN",
          description:
              "Provides an infant and his/her parents with one year of therapies and support at the Me and My Mommy program.",
          features: `Includes (5) Private Guest Links Sponsorship Listing on Website & Special Acknowledgment During Event Receive (5) 1.0 Gallon Gourmet Popcorn Tins (3 flavors of your choice in each tin) sent to up to (5) viewing locations of your choice`,
        },
        {
          amount: 3600,
          title: "CHOREOGRAPHER",
          description:
              "Provides a family with weekly overnight respite for one year at the Respite Center.",
          features: `Includes (4) Private Guest Links Special Acknowledgment During Event Receive (4) 1.0 Gallon Gourmet Popcorn Tins (3 flavors of your choice in each tin) sent to up to (4) viewing locations of your choice`,
        },
        {
          amount: 2500,
          title: "EDITOR",
          description:
              "Provides a child with Autism with 4 speech therapy sessions a week for one year.",
          features: `Includes (3) Private Guest Links Receive (3) 1.0 Gallon Gourmet Popcorn Tins (3 flavors of your choice in each tin) sent to up to (3) viewing locations of your choice`,
        },
        {
          amount: 1800,
          title: "CAST",
          description:
              "Provides a child with a full summer experience, including a 6 week day camp and an 8 day sleep-away camp.",
          features: `Includes (2) Private Guest Links Receive (2) 1.0 Gallon Gourmet Popcorn Tins (3 flavors of your choice in each tin) sent to up to (2) viewing locations of your choice`,
        },
        {
          amount: 1000,
          title: "CRITIC",
          description:
              "Provides tuition for one young adult’s vocational training certification course.",
          features: `Includes (1) Private Guest Link Receive (1) 1.0 Gallon Gourmet Popcorn Tin (3 flavors of your choice)`,
        },
        {
          amount: 500,
          title: "EXTRAS",
          description:
              "Provides a child with weekly art and music therapy sessions for a year.",
          features: `Includes (1) Private Guest Link Receive (1) 1.0 Gallon Gourmet Popcorn Tin (3 flavors of your choice)`,
        },
        {
          amount: 250,
          title: "TICKET",
          description:
              "Provides a class of children in the Rehabilitative Day Care with a month of pet therapy sessions.",
          features: `Includes (1) Private Guest Link`,
        },
      ],
      registration: [
        {
          title: "Registration",
          fields: [
            {
              name: "First Name",
              type: "text",
              required: true,
              slug: "firstName",
            },
            {
              name: "Last Name",
              type: "text",
              required: true,
              slug: 'lastName'
            },
            {
              name: "Street Address",
              type: "text",
              required: true,
              slug: "streetAddress",
            },
            {
              name: "City",
              type: "text",
              required: true,
              slug: "city",
            },
            {
              name: "State",
              type: "text",
              required: true,
              slug: "state",
            },
            {
              name: "Zip Code",
              type: "text",
              required: true,
              slug: "zipCode",
            },
            {
              name: "Phone Number",
              type: "text",
              required: true,
              slug: "phoneNumber",
            },
            {
              name: "Email Address",
              type: "email",
              slug: "emailAddress",
              required: true,
            },
          ],
        },
      ],
      registrationClosed: false,
    };
  },
};
</script>

<style scoped>
.product-price {
  display: inline-block;
  width: 20%;
  vertical-align: top;
  margin-top: 10px;
}

.product-description {
  display: inline-block;
  width: 77%;
}

.form-header {
  background-color: #563d7c;
  border-radius: 10px;
  margin-bottom: 20px;
  color: white;
  padding: 10px 20px 18px;
}

.form-header.warning {
  text-align: center;
}

.form-warning {
  color: white;
  background: red;
  padding: 10px;
  text-align: center;
  font-size: 20px;
  margin: 0 auto 30px auto;
}

.registration-closed {
  padding-bottom: calc(100vh - 440px)
}

.big-input {
  font-weight: 300;
  height: 60px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
  border: 1px solid #c8cdd2;
  font-size: 18px;
  color: #6d7a83;
  -webkit-appearance: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.big-input:focus {
  border-color: #563d7c;
}

.main-image-wrapper {
  height: 240px;
}

.tooltip::after {
  content: "";
  display: block;
  height: 10px;
  width: 10px;
  background: white;
  position: absolute;
  top: -6px;
  transform: rotate(45deg);
}

.tooltip {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 105%;
  background: white;
  padding: 20px 10px 20px 20px;
  box-shadow: 1px 1px 20px lightgray;
  z-index: 2;
  border-radius: 2px;
  width: 50%;
  opacity: 0;
  transition: all ease 0.3s;
}

.sponsership {
  position: relative;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 10px 20px;
  margin-top: 20px;
  overflow: hidden;
  transition: ease-in-out all 0.2s;
}

.sponsership b {
  font-size: 22px;
}

.sponsership:hover {
  overflow: visible;
}

.sponsership:hover .tooltip {
  opacity: 1;
}

.sponsership.active {
  border-color: rgb(41, 179, 102);
}

.active b {
  color: rgb(41, 179, 102);
}

.reg-body {
  background: #fafafa;
  min-height: 100vh;
  text-align: left;
}

form {
  margin: auto;
  background: #eeeeee;
  display: block;
  padding: 40px;
  max-width: 870px;
  width: 95%;
  margin-top: 200px;
  position: relative;
  z-index: 3;
  border-radius: 5px;
}

.w-button {
  border-radius: 100px;
  padding: 7px 40px;
  display: inline-block;
}

@media screen and (max-width: 768px) {
  form {
    width: 100%;
    border-radius: 0;
    margin-top: 120px;
  }

  .product-price {
    display: block;
    width: auto;
  }

  .product-description {
    display: block;
    width: auto;
  }

  .main-image-wrapper {
    height: 120px;
  }
}

.big-input:focus::-webkit-input-placeholder {
  -webkit-transform: translateX(8%);
  transform: translateX(8%);
  opacity: 0;
}

.big-input::-webkit-input-placeholder {
  transition: all ease 0.4s;
}
</style>
